export default "__VITE_ASSET__1p4OGAz$__"